import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { RfaAccessTokenService } from '../services/rfa-access-token.service';

/**
 * Attaches an X-RFA-Token header to /application/* requests when a live
 * (non-expired) RFA access token is present. only portals that
 * call RfaAccessTokenService.setRfaAccessToken() are affected.
 */
@Injectable()
export class RfaAccessTokenInterceptor implements HttpInterceptor {
  constructor(private rfaAccessTokenService: RfaAccessTokenService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const rfaAccessToken = this.rfaAccessTokenService.getRfaAccessToken();
    if (rfaAccessToken && request.url.includes('/application/')) {
      request = request.clone({
        setHeaders: { 'X-RFA-Token': rfaAccessToken },
      });
    }
    return next.handle(request);
  }
}
